import { render, staticRenderFns } from "./examinationTagAssignmentDialog.vue?vue&type=template&id=b401e5ae"
import script from "./examinationTagAssignmentDialog.vue?vue&type=script&lang=js"
export * from "./examinationTagAssignmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports